import { type ReactNode, Suspense } from "react"

import type { ThemeKeys } from "../../theme"
import styles from "./AnimatedSuspense.module.css"

interface AnimatedSuspenseProps {
  children: ReactNode
  fallback?: ReactNode
  animationDuration?: ThemeKeys<"transitionDuration">
}

export function AnimatedSuspense(props: AnimatedSuspenseProps) {
  const { children, fallback, animationDuration = 150 } = props

  return (
    <Suspense fallback={fallback}>
      <div
        className={styles.animatedSuspenseWrapper}
        style={{
          animationDuration: `${animationDuration}ms`,
        }}
      >
        {children}
      </div>
    </Suspense>
  )
}
